// extracted by mini-css-extract-plugin
module.exports = {"heading":"FinanceOptionsExplained_heading__r1fPH","contents":"FinanceOptionsExplained_contents__q3Hof"};